// extracted by mini-css-extract-plugin
module.exports = {"landscape__overlay":"landscape__overlay___3MW1U","landscape__overlay__logo":"landscape__overlay__logo___OWzPT","landscape__overlay__text":"landscape__overlay__text___3CUvq"};
    if(module.hot) {
      // 1677682834796
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  